<arb-base-dialog class="update-dialog" [title]="data.title" [subtitle]="data.subtitle">
  <ng-container content>
    <mat-radio-group [formControl]="statusControl" #radio class="radio-group">
      <mat-radio-button *ngFor="let status of data.statuses" class="radio-button" color="primary" [value]="status">
        {{ toReadableBorrowerStatus(status) }}
      </mat-radio-button>
    </mat-radio-group>
  </ng-container>
  <ng-container actions>
    <button [class.thin]="data.thinButtons" (click)="close(false)" class="action-btn" [color]="data.rejectButtonColor"
            mat-flat-button>
      {{data.rejectButtonText}}
    </button>
    <button [class.thin]="data.thinButtons" [disabled]="statusControl.errors" (click)="close(true)"
            class="action-btn accept" mat-flat-button [color]="data.acceptButtonColor">
      {{ data.acceptButtonText }}
    </button>
  </ng-container>
</arb-base-dialog>
